import { Box, Button, Divider, Grid, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import { getCampusMapLink } from '../utils/API';
import { Styles } from '../styles/global';

const InformCampusLinks = ({ space, customHeight }) => {
  const [links, setLinks] = useState(null);
  const { user } = useAuth();
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await getCampusMapLink();
        setLinks(response?.data?.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchLinks();
  }, []);

  if (!links?.visible) {
    return <></>;
  }

  return (
    <Grid item lg={space || 4} md={space || 6} sm={12} xs={12}>
      <Paper
        {...Styles.dashboardContentWidget({
          lg: space ? 'auto' : customHeight || 360,
          md: 'auto',
        })}
        flex={1}
      >
        {/* Title: Campus Map Links */}
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'flex-start'}
          flexDirection={'column'}
          flex={1}
          width={'100%'}
        >
          <Box flex={1} width={'100%'}>
            <Typography variant="h6" margin={1}>
              Campus Map Links
            </Typography>

            <Divider />

            <Box display={'flex'} flexDirection={'column'} margin={1}>
              <ul>
                {links?.links?.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.value}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link.key}
                    </a>
                  </li>
                ))}
              </ul>
            </Box>
          </Box>
          {user?.role === 'ADMIN' && (
            <Box margin={1}>
              <Link to="/admin/dashboard/config">
                To edit map links, click here
              </Link>
            </Box>
          )}
        </Box>
      </Paper>
    </Grid>
  );
};

export default InformCampusLinks;
